function setViewAllBlogLinks(searchedText) {
  if (searchedText) {
    const storeURL =  "https://" + window.location.hostname;
    var blogResultLink = storeURL + "/search?q=" + searchedText + "&view=blog&type=article";
  }

  var blogResultSelectors = document.querySelectorAll('#blog-search-result-link');
  if(blogResultSelectors) {
    blogResultSelectors.forEach((blogResultSelector) => {
      blogResultSelector.href = blogResultLink;
    });
  }
}

function setMobileBlogSearchResult() {
  var searchedText = document.getElementById('Search-In-Modal-mobile').value;
  setViewAllBlogLinks(searchedText);
}

function setTabletBlogSearchResult() {
  var searchedText = document.getElementById('Search-In-Modal-1').value;
  setViewAllBlogLinks(searchedText);
}

function setDesktoptBlogSearchResult() {
  var searchedText = document.getElementById('header-search-input').value;
  setViewAllBlogLinks(searchedText);
}

function handleAutoCompleteChanges(mutationsList, observer) {
  mutationsList.forEach((mutation) => {
    const autoCompleteDiv = document.querySelectorAll('.algolia-autocomplete');
    const isAutoCompleteVisible = autoCompleteDiv && autoCompleteDiv[0].style.display === 'block';
    const searchBarCoverDiv = document.getElementById('searchBarCover');
    const searchBarField = document.querySelector('.search_bar--desktop');

    if (isAutoCompleteVisible) {
      if (searchBarCoverDiv && searchBarField) {
        searchBarCoverDiv.classList.add('searchBarCoverFaded');
        searchBarField.classList.add('searchBarDesktop');
      }
      autoCompleteDiv[0].style.width = '1000px';
    } else {
      if (searchBarCoverDiv && searchBarField ) {
        searchBarCoverDiv.classList.remove('searchBarCoverFaded');
        searchBarField.classList.remove('searchBarDesktop');
      }
    }
  });
}

function searchBarDesktop() {
  const autoCompleteObserver = new MutationObserver(handleAutoCompleteChanges);
  const autoCompleteTargetNode = document.querySelector('.algolia-autocomplete');
  const config = { attributes: true, subtree: true, childList: true };
  autoCompleteObserver.observe(autoCompleteTargetNode, config);

  const searchBarDesktopCover = document.getElementById('SearchBarCover');
  const searchBarDesktop = document.querySelector('.search_bar--desktop');
  if (searchBarDesktopCover) {
    searchBarDesktopCover.addEventListener('click', function (event) {
      if (searchBarDesktopCover && searchBarDesktop) {
        searchBarDesktopCover.classList.remove('searchBarCoverFaded');
        searchBarDesktop.classList.remove('searchBarDesktop');
      }
    });
  }
}

searchBarDesktop();

function searchBarMobileDoneButtonFix() {
  const mobileAutoCompleteDiv = document.querySelectorAll('.algolia-autocomplete');
  const mobileSearchBar = document.getElementById('Search-In-Modal-mobile');
  const moduleCloseButton = document.querySelector('.modal__close-button--mobile');
  const searchCloseButton = document.querySelector('.close-search__button');
  const disableScrollMobile = document.querySelector('html');

  mobileSearchBar.addEventListener("blur", (event) => {
    if (mobileSearchBar.value.length != 0) {
      mobileAutoCompleteDiv[1].style.display = 'block';
      if (moduleCloseButton.clicked == true) {
        mobileAutoCompleteDiv[1].style.display = 'none';
      }
    } else {
      mobileAutoCompleteDiv[1].style.display = 'none';
    }
  }); 
  
  mobileSearchBar.addEventListener('input', function (event) {
    if (mobileSearchBar.value.length != 0) {
      disableScrollMobile.classList.add('disableScroll');
    } else {
      disableScrollMobile.classList.remove('disableScroll');
      mobileAutoCompleteDiv[1].style.display = 'none';
    }
  });

  searchCloseButton.addEventListener('click', function (event) {
    disableScrollMobile.classList.remove('disableScroll');
    mobileAutoCompleteDiv[1].style.display = 'none';
  });

  moduleCloseButton.addEventListener('click', function (event) {
    disableScrollMobile.classList.remove('disableScroll');
    mobileAutoCompleteDiv[1].style.display = 'none';
  });
}
searchBarMobileDoneButtonFix();